import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import * as PropTypes from "prop-types";
import { SearchkitComponent, renderComponent } from "../../../../core";

var defaults = require("lodash/defaults");

export var InitialViewDisplay =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(InitialViewDisplay, _React$PureComponent);

  function InitialViewDisplay() {
    _classCallCheck(this, InitialViewDisplay);

    return _possibleConstructorReturn(this, _getPrototypeOf(InitialViewDisplay).apply(this, arguments));
  }

  _createClass(InitialViewDisplay, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: this.props.bemBlocks.container()
      }, React.createElement("div", {
        "data-qa": "initial-loading",
        className: this.props.bemBlocks.container("initial-loading")
      }));
    }
  }]);

  return InitialViewDisplay;
}(React.PureComponent);
export var InitialLoader =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(InitialLoader, _SearchkitComponent);

  function InitialLoader() {
    _classCallCheck(this, InitialLoader);

    return _possibleConstructorReturn(this, _getPrototypeOf(InitialLoader).apply(this, arguments));
  }

  _createClass(InitialLoader, [{
    key: "defineBEMBlocks",
    value: function defineBEMBlocks() {
      var block = this.props.mod || "sk-initial-loader";
      return {
        container: block
      };
    }
  }, {
    key: "render",
    value: function render() {
      if (this.isInitialLoading()) {
        return renderComponent(this.props.component, {
          bemBlocks: this.bemBlocks
        });
      }

      return null;
    }
  }]);

  return InitialLoader;
}(SearchkitComponent);
InitialLoader.defaultProps = {
  component: InitialViewDisplay
};
InitialLoader.propTypes = defaults({
  component: PropTypes.func
}, SearchkitComponent.propTypes);